// Client validation mirrors server limits; Functions validate every write again.
export function validWebshopPrice(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value) && value >= 0.005 && value <= 1_000_000;
}

export function validWebshopVat(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value) && value >= 0 && value <= 100 &&
    /^\d+(?:\.\d{1,2})?$/.test(String(value));
}
